export const cdp = {
	tabs: {
		dashboard: "Visión general",
		customers: "Lista de Clientes",
		rfmAnalysis: "Comportamiento de clientes",
		segments: "Segmentos",
	},
	common: {
		loading: "Cargando...",
	},
	header: {
		title: "Panel CRM",
		subtitle:
			"Conoce, monitoriza y activa tu base de clientes, convirtiendo datos en campañas y ventas",
	},
	rfm: {
		labels: {
			champions: "Campeones",
			loyal: "Leales",
			highPotential: "Alto Potencial",
			promising: "Prometedores",
			recent: "Recientes",
			attention: "Atención",
			canNotLose: "No Podemos Perderlos",
			risk: "En Riesgo",
			closeToHibernation: "A Punto de Hibernar",
			hibernating: "Hibernando",
			lost: "Perdidos",
		},
		descriptions: {
			champions: "Compraron hace poco, vienen con frecuencia y gastan mucho",
			loyal: "Vuelven con buena frecuencia y compraron recientemente",
			highPotential: "Compraron hace poco con buen gasto — casi fieles",
			promising: "Compra reciente con buenas señales de frecuencia y gasto",
			recent: "Compraron hace poco, pero aún con pocas visitas",
			attention: "Recencia media — necesitan un estímulo para volver",
			canNotLose: "Gastaban mucho, pero no compran desde hace mucho tiempo",
			risk: "Ya compraron bien, pero llevan tiempo enfriándose",
			closeToHibernation: "Recencia y frecuencia bajas — casi inactivos",
			hibernating: "Compras antiguas, con frecuencia y gasto bajos",
			lost: "Compraron poco, gastaron poco y no volvieron",
		},
	},
	dashboard: {
		title: "Panel CDP",
		subtitle:
			"Haz un seguimiento de tus clientes, métricas de relación y segmentación inteligente",
		filters: {
			period: {
				label: "Período",
				options: {
					last7Days: "Últimos 7 días",
					last15Days: "Últimos 15 días",
					last30Days: "Últimos 30 días",
					last60Days: "Últimos 60 días",
					last90Days: "Últimos 90 días",
				},
			},
			groupBy: {
				label: "Agrupar por",
				options: {
					week: "Semana",
					month: "Mes",
				},
			},
			establishments: {
				label: "Establecimientos",
				all: "Todos",
			},
			apply: "Filtrar",
		},
		advanced: {
			top10Title: "Top 10 Clientes por Valor",
			noClients: "No se ha encontrado ningún cliente",
			visitsPerMonth: "visitas/mes",
			viewTop100: "Ver los mejores clientes",
			sectionTitle: "Análisis Avanzados",
			sectionSubtitle: "Visualización detallada del valor de los clientes",
			rankingTitle: "Top {{count}} Clientes por Valor",
			viewMore: "Ver más",
			viewLess: "Ver menos",
		},
		alerts: {
			title: "Alertas y Riesgos",
			subtitle: "Indicadores de atención para tu base de clientes",
			cards: {
				inactive: {
					title: "Clientes Inactivos",
					label: "Inactivos desde hace 90+ días",
					tooltip: "Considera los últimos 90 días a partir de hoy.",
					ofBase: "de la base",
					anomalyTooltip:
						"El porcentaje de inactivos supera el 100 % de la base activa. Esto puede indicar una inconsistencia en los datos: los clientes podrían estar contándose en varios locales o el total de la base podría no incluir a todos los clientes históricos.",
				},
				balance: {
					title: "Créditos Disponibles",
					tooltip:
						"Saldo de recargas que los clientes cargaron y aún no han gastado (excluye recargas reembolsadas o caducadas). Es dinero parado en el local: un buen motivo para llamar a estos clientes de vuelta.",
					clients: "Clientes",
					percentOfBase: "% de la base",
					averagePerClient: "Media/cliente",
				},
				churn: {
					title: "Clientes en Riesgo de Abandono",
				},
			},
		},
		demographics: {
			title: "Análisis Demográfico",
			subtitle: "Perfil demográfico de tu base de clientes",
			genderTitle: "Distribución por Género",
			ageTitle: "Distribución por Franja de Edad",
			ageMissingBirthDate:
				"⚠ El {{percentage}} % de los clientes no tienen fecha de nacimiento registrada y quedan excluidos",
			genders: {
				male: "Masculino",
				female: "Femenino",
				other: "Otro",
				notInformed: "No indicado",
			},
		},
		evolution: {
			title: "Evolución Temporal",
			subtitle:
				"Haz un seguimiento de la evolución de las métricas a lo largo del tiempo",
			yAxisClients: "Clientes",
			referenceAverage: "Media",
			clientsTooltip: "{{value}} clientes",
			activeBase: {
				title: "Evolución de la Base Activa",
				subtitle: "Clientes únicos por período",
			},
			averageTicket: {
				title: "Evolución del Ticket Medio",
				subtitle: "Valor medio por visita",
			},
			newVsRecurring: {
				title: "Nuevos vs. Recurrentes",
				subtitle: "Composición de la base a lo largo del tiempo",
				newClients: "Nuevos",
				recurringClients: "Recurrentes",
			},
			activation: {
				title: "Tasa de Activación a lo Largo del Tiempo",
				subtitle:
					"Conversión de nuevos en recurrentes · ventana móvil de 180 días · vs. mismo período del año anterior",
				currentSeries: "Actual",
				previousSeries: "Año anterior",
			},
		},
		health: {
			title: "Salud de la Base",
			subtitle: "Visión general de los principales indicadores de clientes",
			variationTooltip: "Variación respecto al período anterior",
			activeClients: {
				label: "Clientes Activos",
				subLabel: "Clientes únicos en el período",
				tooltip:
					"Clientes identificados (CPF/teléfono) con al menos una interacción en el período seleccionado",
			},
			averageTicket: {
				label: "Ticket Medio",
				subLabel: "Valor medio por visita",
			},
			activationRate: {
				label: "Tasa de Activación",
				subLabel: "Conversión de nuevos en recurrentes",
				tooltip: "Porcentaje de nuevos clientes que volvieron para una segunda visita",
				variationSuffix: " p.p.",
			},
			reactivated: {
				label: "Clientes Reactivados",
				subLabel: "Inactivos que volvieron",
				tooltip: "Clientes que estaban inactivos (>30 días) y regresaron en el período",
			},
			interval: {
				label: "Intervalo Medio",
				subLabel: "Días entre visitas",
				tooltip: "Cuanto menor, mejor: indica un mayor compromiso",
				daysValue: "{{days}} días",
			},
		},
		rfmSection: {
			sectionTitle: "Análisis de Clientes",
			sectionSubtitle: "Distribución de la base por clasificación RFM",
			chartTitle: "Distribución RFM",
			chartSubtitle:
				"Distribución de la base completa · haz clic en un segmento para ver los detalles · ordena por las columnas",
		},
		rfmDistribution: {
			columns: {
				name: "Clasificación",
				percentage: "% de la base",
				count: "Clientes",
				averageTicket: "Ticket medio",
				totalTpv: "TPV",
			},
			rowTitle: "Ver los clientes de este segmento",
		},
		segmentsSection: {
			title: "Segmentos Personalizados",
			emptySubtitle: "Agrupa a los clientes por comportamiento y sigue sus indicadores",
			emptyTitle: "No se ha encontrado ningún segmento personalizado",
			emptyText:
				'Crea segmentos para agrupar a los clientes por comportamiento —por ejemplo "VIP" o "Ausentes con saldo"— y sigue las cifras de cada grupo aquí en el panel.',
			createButton: "Crear segmento",
			subtitle: "Haz clic en un segmento para ver los clientes",
			columnName: "Nombre del Segmento",
			columnCount: "Clientes",
			columnPercentage: "% Base",
			columnAverageTicket: "Ticket Medio",
			columnActions: "Acciones",
			editSegment: "Editar segmento",
			deleteSegment: "Eliminar segmento",
		},
		mixClients: {
			title: "Mix de Clientes",
			new: "Nuevos",
			recurring: "Recurrentes",
			reactivated: "Reactivados",
		},
		valueMatrix: {
			loading: "Cargando…",
			noData: "Sin datos en el período.",
			title: "Concentración de clientes",
			total: "Total: {{total}} clientes",
			yAxisTitle: "ticket medio (R$)",
			xAxisTitle: "media de visitas/mes",
			cellTitle: "{{ticket}}  ·  {{frequency}} visitas/mes: {{clients}} clientes",
		},
	},
	customers: {
		title: "Lista de Clientes",
		subtitle: "Busca y filtra clientes de tu base",
		globalFilters: {
			placeLabel: "Local",
			placePlaceholder: "Todos los locales",
			searchPlaceholder: "Buscar...",
			noResults: "Sin resultados",
			baseLabel: "Base considerada",
			baseOptions: {
				all: "Toda la base",
				last90Days: "Últimos 90 días",
				last180Days: "Últimos 180 días",
				last365Days: "Últimos 365 días",
			},
		},
		relativeTime: {
			today: "hoy",
			daysAgo_one: "hace {{count}} día",
			daysAgo_other: "hace {{count}} días",
			monthsAgo_one: "hace {{count}} mes",
			monthsAgo_other: "hace {{count}} meses",
			yearsAgo_one: "hace {{count}} año",
			yearsAgo_other: "hace {{count}} años",
		},
		classificationView: {
			label: "Clasificación del cliente:",
			all: "Todos los locales",
			best: "Solo la mejor",
		},
		filters: {
			removePill: "Quitar {{label}}",
			search: {
				label: "Buscar",
				placeholder: "Buscar por nombre, correo, teléfono o documento...",
			},
			listSearch: {
				placeholder: "Buscar...",
				noResults: "Sin resultados",
			},
			place: {
				label: "Local",
				placeholder: "Todos los locales",
				selectedCount: "{{count}} seleccionados",
			},
			rfmClassification: {
				label: "Clasificación RFM",
				placeholder: "Todas las clasificaciones",
				selectedCount: "{{count}} seleccionadas",
			},
			clientClassification: {
				label: "Clasificación RFM multilocal",
				tooltip:
					"Cuando el cliente ha visitado varios locales y tiene clasificaciones diferentes, este filtro define qué clasificación se muestra.",
				all: "Mostrar todas las clasificaciones",
				best: "Mostrar solo la mejor",
			},
			segments: {
				label: "Segmentos",
				placeholder: "Todos los segmentos",
				selectedCount: "{{count}} seleccionados",
			},
			allowCommunication: {
				label: "Permite Comunicación",
				all: "Todos",
				yes: "Sí",
				no: "No",
			},
			status: {
				label: "Estado",
				placeholder: "Todos los estados",
				selectedCount: "{{count}} seleccionados",
			},
			gender: {
				label: "Género",
				placeholder: "Todos los géneros",
				selectedCount: "{{count}} seleccionados",
				male: "Masculino",
				female: "Femenino",
				other: "Otro",
			},
			lastInteraction: {
				label: "Última Interacción",
				placeholder: "Cualquier fecha",
				last7Days: "Últimos 7 días",
				last30Days: "Últimos 30 días",
				last60Days: "Últimos 60 días",
				last90Days: "Últimos 90 días",
				moreThan90Days: "Más de 90 días",
				custom: "Personalizado",
			},
			activityPeriod: {
				label: "Período de Actividad",
				from: "Desde",
				to: "Hasta",
				lastDays: "Últimos {{count}} días",
				shortcutsLabel: "Últimos:",
			},
			balance: {
				label: "Saldo Disponible",
				onlyWithBalance: "Solo con saldo",
				minBalance: "Saldo mínimo (R$)",
			},
			consumptionMin: {
				label: "Consumo mínimo (R$)",
				placeholder: "Ej.: 100",
			},
			avgTicketMin: {
				label: "Ticket medio mínimo (R$)",
				placeholder: "Ej.: 50",
			},
			presences: {
				label: "Mínimo de visitas",
				labelTotal: "Mínimo de visitas (total)",
				any: "Cualquiera",
				option: "{{count}}+ visitas",
				placeholder: "Ej.: 3",
			},
			birthday: {
				label: "Período de cumpleaños",
				from: "Desde",
				to: "Hasta",
				shortcutsLabel: "Sugerencias:",
				thisMonth: "Este mes",
				nextMonth: "Próximo mes",
				invalidDate: "Fecha no válida.",
				dayColumn: "Día",
				monthColumn: "Mes",
			},
			birthYear: {
				label: "Edad",
				modeAge: "Edad",
				modeYear: "Año",
				yearLabel: "Año de nacimiento",
				from: "Desde",
				to: "Hasta",
			},
			rangeError: "“Hasta” debe ser mayor que “Desde”.",
			product: {
				label: "Producto",
				placeholder: "Todos los productos",
				selectedCount: "{{count}} seleccionados",
			},
			sections: {
				activity: "Actividad y consumo",
				demographics: "Demografía",
			},
			advanced: {
				show: "Más filtros",
				hide: "Menos filtros",
				drawerButton: "Filtros",
				drawerTitle: "Filtros de la lista",
				drawerApply: "Ver {{value}} clientes",
				sectionDemographics: "Demografía",
				sectionActivity: "Consumo",
				sectionStatus: "Estado",
			},
			actions: {
				apply: "Aplicar Filtros",
				clear: "Borrar Filtros",
			},
			results: "{{value}} clientes encontrados",
			searching: "Buscando clientes...",
			segmentMerge: {
				eyebrow: "Segmento",
				hint:
					"Las reglas de cada segmento rellenan los filtros de abajo. Puedes afinarlos a tu gusto.",
				appliedTitle: "Filtros aplicados",
				appliedByOne: "provenientes de 1 segmento",
				appliedByMany: "provenientes de {{count}} segmentos",
				editableBadge: "editable",
				markerApplied: "Segmento aplicado",
				markerCombined: "Segmento combinado",
				markerAdjusted: "Segmento ajustado",
				appliedFrom: "Este filtro proviene del segmento {{segment}}.",
				appliedActivity:
					"Activos en los últimos {{days}} días, definido por el segmento {{segments}}.",
				combinedFrom: "Este filtro une los segmentos: {{segments}}.",
				combinedWithManual: "Une los segmentos {{segments}} más tu selección manual.",
				conflictMsg:
					"Más de un segmento define este filtro. Prevalece el del último seleccionado: {{used}} ({{usedValue}}).",
				activityAdjusted:
					"Los segmentos usan ventanas diferentes. Usamos la mayor: {{days}} días.",
			},
		},
		table: {
			columns: {
				name: "Cliente",
				contact: "Contacto",
				cpf: "CPF",
				classification: "Clasificación",
				behavior: "Comportamiento",
				birthDate: "Cumpleaños",
				firstVisit: "1.ª vez",
				totalPaid: "Total pagado",
				averageTicket: "Tkt Medio",
				balance: "Saldo disponible",
				hasApp: "Aplicación activa",
				actions: "Acciones",
			},
			visits: "{{count}} visitas",
			lastVisit: "Última visita",
			classificationPlace: "{{places}}",
			classificationPlaces: "{{places}}",
			uninformed: "No indicado",
			appActive: "Sí",
			appInactive: "No",
			hasAppTitle: "Aplicación activa",
			balanceShort: "Saldo",
			firstVisitShort: "Primera visita",
			lastVisitShort: "Última visita",
			noName: "Sin nombre",
			ago: "hace {{days}} días",
			totalPaid: "Total pagado",
			averageTicket: "Ticket medio",
			balance: "Saldo",
			viewDetails: "Ver Detalles",
			details: "Detalles",
			noResults: "No se ha encontrado ningún cliente",
			noResultsDescription: "Prueba a ajustar los filtros para encontrar clientes",
		},
		status: {
			active: "Activo",
			attention: "Atención",
			risk: "Riesgo",
			inactive: "Inactivo",
		},
		drawer: {
			title: "Detalles del Cliente",
			noName: "Sin nombre",
			tabs: {
				summary: "Resumen",
				favoriteProducts: "Productos Favoritos",
				history: "Historial",
				purchases: "Visitas",
			},
			summary: {
				personalData: "Datos Personales",
				document: "Documento",
				email: "Correo electrónico",
				phone: "Teléfono",
				birthDate: "Nacimiento",
				ageYears: "{{age}} años",
				gender: "Género",
				city: "Ciudad",
				location: "Local",
				preferences: "Preferencias",
				allowsCommunication: "Permite Comunicación",
				communicationDenied: "No permite comunicación",
				appInstalled: "App instalada",
				noApp: "Sin app",
				activitySummary: "Resumen de Actividad",
				firstVisit: "Primera Visita",
				lastVisit: "Última Visita",
				totalVisits: "Total de Visitas",
				averageFrequency: "Frecuencia Media",
				visitsPerMonth: "visitas/mes",
				customerFor: "Días como cliente",
				financial: "Financiero",
				totalPaid: "Total Pagado",
				averageTicket: "Ticket Medio",
				availableBalance: "Saldo Disponible",
				classifications: "Clasificaciones",
				rfmByPlace: "RFM por Establecimiento",
				segments: "Segmentos",
			},
			products: {
				product: "Producto",
				category: "Categoría",
				quantity: "Cantidad",
				totalValue: "Valor Total",
				lastPurchase: "Última Compra",
				top10: "Top 10 Productos",
				sortByQuantity: "Por cantidad",
				sortByValue: "Por valor",
				noProducts: "No se ha encontrado ningún producto favorito",
			},
			history: {
				filterByType: "Filtrar por tipo",
				allTypes: "Todos los tipos",
				loadMore: "Cargar más",
				noHistory: "No se ha encontrado ningún historial",
				noPlace: "Sin establecimiento",
				unknownPlace: "Otro establecimiento",
				interaction: "visita",
				interactions: "visitas",
				firstShort: "1.ª:",
				lastShort: "última:",
				items: "artículos",
			},
			purchases: {
				product: "Producto",
				category: "Categoría",
				quantity: "Cant.",
				unitPrice: "Precio Unit.",
				total: "Total",
				date: "Fecha",
				noPurchases: "No se ha encontrado ninguna compra",
				loadMore: "Cargar más",
				visitTotal: "Total de la visita",
				visitNoItems: "Sin consumo registrado",
				unitSuffix: "un.",
				discount: "Descuento",
				noPlace: "Sin establecimiento",
				unknownPlace: "Otro establecimiento",
				loadingMore: "Cargando más visitas…",
			},
			actions: {
				close: "Cerrar",
				addToSegment: "Añadir a Segmento",
				edit: "Editar",
			},
		},
		genders: {
			male: "Masculino",
			female: "Femenino",
			other: "Otro",
			unknown: "No indicado",
		},
		interactionTypes: {
			presence: "Presencia",
			recharge: "Recarga",
			giftbackRescue: "Canje Giftback",
			giftbackExpire: "Caducidad Giftback",
			giftbackReceive: "Recepción Giftback",
			ticketPurchase: "Compra de Entrada",
			ticketCancel: "Cancelación de Entrada",
			communication: "Comunicación",
			rfmMigration: "Migración RFM",
		},
		labels: {
			status: {
				active: "Activo",
				attention: "Atención",
				risk: "Riesgo",
				inactive: "Inactivo",
			},
			interaction: {
				Event: "Evento",
				TicketOrder: "Pedido de Entrada",
				NpsSurveyAnswer: "Respuesta NPS",
				Communication: "Comunicación",
				SegmentAlteration: "Cambio de Segmento",
			},
		},
	},
	segments: {
		title: "Segmentos",
		subtitle: "Crea y gestiona segmentos personalizados de clientes",
		summary: {
			highestRevenue: "Segmento con mayor ingreso",
			highestTicket: "Segmento con mayor ticket medio",
			mostCustomers: "Segmento con más clientes",
			leastCustomers: "Segmento con menos clientes",
		},
		search: {
			placeholder: "Buscar segmento...",
		},
		actions: {
			create: "Crear segmentación",
			edit: "Editar",
			delete: "Eliminar",
			duplicate: "Duplicar",
		},
		card: {
			createdBy: "Creado por: {{name}}",
			leads: "{{count}} leads",
			metrics: {
				clients: "Clientes",
				revenue: "Ingreso",
				avgTicket: "Ticket medio",
				baseShare: "% de la base",
			},
			lastSync: "Última sincronización: {{date}}",
			neverSynced: "Nunca sincronizado",
			syncStatus: {
				synced: "Sincronizado",
				outdated: "Desactualizado",
				outdatedTooltip:
					"El segmento se modificó después de la última sincronización y necesita reprocesarse.",
				neverTooltip: "Este segmento aún no se ha sincronizado.",
			},
		},
		drawer: {
			titleCreate: "Crear segmento",
			titleEdit: "Editar segmento",
			fields: {
				name: "Nombre",
				namePlaceholder: "Nombre del segmento",
				description: "Descripción",
				descriptionPlaceholder: "Describe el objetivo de este segmento",
				analysisPeriod: "Activos en los últimos N días",
				analysisPeriodPlaceholder: "Ej.: 30 (vacío = cualquiera)",
				analysisPeriodShortcuts: "Sugerencias:",
			},
			rules: {
				title: "Reglas de Segmentación",
				demographic: "Demográficas",
				consumption: "Consumo",
				engagement: "Compromiso",
				status: "Estado",
				gender: {
					label: "Género",
					placeholder: "Selecciona los géneros",
					male: "Masculino",
					female: "Femenino",
					other: "Otro",
				},
				birthday: {
					label: "Cumpleaños (día/mes)",
					from: "Desde",
					to: "Hasta",
					shortcutsLabel: "Sugerencias:",
					thisMonth: "Este mes",
					nextMonth: "Próximo mes",
					invalidDate: "Fecha no válida.",
				},
				birthYear: {
					label: "Edad",
					modeAge: "Edad",
					modeYear: "Año",
					yearLabel: "Año de nacimiento",
					from: "Desde",
					to: "Hasta",
				},
				rangeError: "“Hasta” debe ser mayor que “Desde”.",
				listSearch: {
					placeholder: "Buscar...",
					noResults: "Sin resultados",
				},
				minPresences: {
					label: "Visitas mínimas",
					placeholder: "Mínimo de visitas en el período",
				},
				minTotalPaid: {
					label: "Valor total mínimo",
					placeholder: "R$ 0,00",
					tooltip:
						"Valor mínimo acumulado gastado por el cliente en el período de análisis definido. Solo se incluirán en el segmento los clientes con un gasto total igual o superior a este valor.",
				},
				minAvgTicket: {
					label: "Ticket medio mínimo",
					placeholder: "R$ 0,00",
				},
				minRemainingBalance: {
					label: "Saldo mínimo disponible",
					placeholder: "R$ 0,00",
				},
				rfmClassification: {
					label: "Clasificación RFM",
					placeholder: "Selecciona las clasificaciones",
				},
				allowCommunication: {
					label: "Permite comunicación",
					any: "Cualquiera",
					yes: "Sí",
					no: "No",
				},
			},
			actions: {
				save: "Guardar",
				cancel: "Cancelar",
				saving: "Guardando...",
			},
			validation: {
				nameRequired: "El nombre es obligatorio",
				descriptionRequired: "La descripción es obligatoria",
				analysisPeriodRequired: "El período de análisis es obligatorio",
				analysisPeriodMin: "El período debe ser mayor que 0",
			},
		},
		deleteModal: {
			title: "Eliminar segmento",
			message:
				'¿Seguro que quieres eliminar el segmento "{{name}}"? Esta acción no se puede deshacer.',
			confirm: "Eliminar",
			cancel: "Cancelar",
			deleting: "Eliminando...",
		},
		empty: {
			title: "No se ha encontrado ningún segmento",
			description: "Crea tu primer segmento para empezar a organizar a tus clientes.",
			searchEmpty: "Ningún segmento coincide con tu búsqueda.",
		},
		toast: {
			createSuccess: "Segmento creado correctamente",
			updateSuccess: "Segmento actualizado correctamente",
			deleteSuccess: "Segmento eliminado correctamente",
		},
	},
	rfmAnalysis: {
		title: "Análisis RFM",
		subtitle: "Análisis de Recencia, Frecuencia y Valor Monetario de los clientes",
		configButton: "Configurar parámetros",
		rangesButton: "Reglas de clasificación",
		countingNote:
			"Recuento por local: un cliente con clasificaciones diferentes entre locales se cuenta en cada uno de ellos; la suma de las clases puede superar el nº de clientes únicos.",
		viewModes: {
			simplified: "Simplificado",
			detailed: "Detallado",
		},
		filters: {
			establishment: "Establecimiento",
			allEstablishments: "Todos los establecimientos",
			period: "Período",
			groupBy: "Agrupar por",
			periods: {
				last7Days: "Últimos 7 días",
				last15Days: "Últimos 15 días",
				last30Days: "Últimos 30 días",
				last60Days: "Últimos 60 días",
				last90Days: "Últimos 90 días",
			},
			groupByOptions: {
				week: "Por semana",
				month: "Por mes",
			},
		},
		charts: {
			distributionTitle: "Cantidad por Estado RFM a lo Largo del Tiempo",
			distributionSubtitle: "Evolución de la distribución de clientes",
			donutTitle: "Distribución de Clientes",
			donutSubtitle: "Segmentación por clasificación RFM",
			treemapTitle: "Distribución RFM",
			treemapSubtitle: "Haz clic en un segmento para ver los detalles",
			stackedAreaTitle: "Composición de la Base a lo Largo del Tiempo",
			stackedAreaSubtitle: "Evolución de los segmentos RFM",
			total: "Total",
			clients: "clientes",
			visible: "Visible",
			donutTooltip: "{{value}} clientes ({{percentage}} %)",
		},
		table: {
			title: "Desglose por Clasificación RFM",
			subtitle: "Métricas detalladas de cada segmento",
			columns: {
				classification: "Clasificación",
				clients: "Clientes",
				percentBase: "% Base",
				totalTpv: "TPV Total",
				percentTpv: "% TPV",
				averageTicket: "Ticket Medio",
			},
			total: "Total",
			noData: "No hay datos disponibles para el período seleccionado",
			rowTitle: "Ver los clientes de este segmento",
			showInChart: "Haz clic para mostrar en el gráfico",
			hideFromChart: "Haz clic para ocultar del gráfico",
		},
		cards: {
			averageTicket: "Ticket Medio",
		},
		summaryCards: {
			groupTitle: "Ver los clientes de este grupo",
		},
		groups: {
			fieis: "Clientes óptimos",
			promissores: "Clientes buenos",
			emRisco: "Clientes en alerta",
			perdidos: "Clientes en estado crítico",
		},
		quintileRanges: {
			title: "Reglas de clasificación",
			subtitle:
				"Franjas de Recencia, Frecuencia y Ticket usadas para clasificar a los clientes de este local (quintiles calculados sobre la base activa del propio local)",
			placePlaceholder: "Establecimiento",
			searchPlaceholder: "Buscar...",
			noResults: "Sin resultados",
			columnClassification: "Clasificación",
			columnRecency: "Recencia (última visita)",
			columnFrequency: "Frecuencia (visitas)",
			columnTicket: "Ticket medio por visita",
			footnoteMain:
				"Franjas recalculadas diariamente a partir del comportamiento del propio local",
			footnoteReference: " (referencia: {{date}})",
			footnoteLegend:
				". “—” = franja no alcanzable en este local (poca variación en la base).",
			ranges: {
				empty: "—",
				recencyAny: "cualquier recencia",
				recencyUpTo: "hasta {{value}} días",
				recencyMoreThan: "más de {{value}} días",
				recencyExact: "{{value}} días",
				recencyBetween: "de {{min}} a {{max}} días",
				frequencyAny: "cualquier nº de visitas",
				frequencySingle: "1 visita",
				frequencyUpTo: "hasta {{value}} visitas",
				frequencyAtLeast: "{{value}}+ visitas",
				frequencyExact_one: "{{value}} visita",
				frequencyExact_other: "{{value}} visitas",
				frequencyBetween: "de {{min}} a {{max}} visitas",
				ticketAny: "cualquier ticket",
				ticketUpTo: "hasta {{value}}",
				ticketAbove: "por encima de {{value}}",
				ticketBetween: "de {{lower}} hasta {{upper}}",
			},
		},
		treemap: {
			clients: "clientes",
			ofBase: "de la base",
			averageTicketLabel: "Ticket medio",
			noData: "Sin datos en el período.",
		},
		configModal: {
			title: "Configurar Parámetros RFM",
			warning:
				"Cambiar las reglas RFM recalculará la clasificación de todos los clientes. Esta operación puede tardar unos minutos en procesarse.",
			resetButton: "Restaurar Predeterminado",
			cancelButton: "Cancelar",
			saveButton: "Guardar Configuración",
			savingButton: "Guardando...",
		},
		errors: {
			loadTitle: "Error al cargar los datos",
			loadText:
				"No se han podido cargar los datos del análisis RFM. Por favor, inténtalo de nuevo.",
			retryButton: "Intentar de nuevo",
		},
		empty: {
			title: "Sin datos para mostrar",
			text:
				"No hay datos suficientes para generar el análisis RFM en el período seleccionado. Prueba a seleccionar un período mayor o espera a que haya más interacciones de los clientes.",
		},
		toast: {
			saveSuccess: "Configuración RFM guardada correctamente",
			saveError: "Error al guardar la configuración RFM",
			resetSuccess: "Configuración RFM restaurada al valor predeterminado",
		},
	},
};
